import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogSize } from '@wcg/frontend-framework';

export interface DialogData {
  title: string;
  message: string;
  dialogSize: DialogSize;
  buttonTitle: string;
  isDefault: boolean;
  dataList: {
    id: string;
    value: string;
  }[];
  alertMessage?: string;
  updateTitle?: string;
}

@Component({
  selector: 'app-contact-delete',
  templateUrl: './contact-delete.component.html',
  styleUrls: ['./contact-delete.component.scss'],
  standalone: false,
})
export class ContactDeleteComponent {
  public dialogRef = inject(MatDialogRef<ContactDeleteComponent>);
  public data: DialogData = inject(MAT_DIALOG_DATA);

  selectedDefaultvalue: any;
  dataObj = this.data;

  cancel() {
    this.dialogRef.close({
      event: 'cancel',
    });
  }

  deleteContactInfo(btnEvent: string, defaultvalue?: any) {
    this.dialogRef.close({
      event: 'delete',
      btnEvent: btnEvent,
      defaultvalue: defaultvalue,
    });
  }
}
